import api from './api';

const resource = 'ReferralAdmin/';

export const getSettings = async () => {
  return await api.get(resource + 'Settings');
};

export const updateSettings = async (body) => {
  return await api.put(resource + 'Settings', body);
};

export const rewards = async (query) => {
  return await api.get(resource + 'Rewards' + query);
};

export const approve = async (id) => {
  return await api.post(resource + 'Approve?id=' + id);
};

export const reject = async (id, body) => {
  return await api.post(resource + 'Reject?id=' + id, body);
};

export const revokeCredit = async (rewardId, body) => {
  return await api.post(resource + 'RevokeCredit?rewardId=' + rewardId, body);
};

export const getReward = async (id) => {
  return await api.get(resource + 'Rewards/' + id);
};

export const companyBalance = async (companyId) => {
  return await api.get(resource + 'Company/' + companyId + '/Balance');
};

export const evaluateActivation = async (referredCompanyId) => {
  return await api.post(
    resource + 'EvaluateActivation?referredCompanyId=' + referredCompanyId,
  );
};

const referralAdminApi = {
  getSettings,
  updateSettings,
  rewards,
  approve,
  reject,
  revokeCredit,
  getReward,
  companyBalance,
  evaluateActivation,
};

export default referralAdminApi;
